// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import infEntity from './entities/inf.json';
import infMenu from '../pages/inf/menu.json';
import infFullForm from '../pages/inf/forms/full.json';
import infContextForm from '../pages/inf/forms/context.json';
import infMiniForm from '../pages/inf/forms/mini.json';
import infLookupForm from '../pages/inf/forms/lookup.json';
import infTableView from '../pages/inf/views/table.json';
import infStagesView from '../pages/inf/views/stages.json';
import infCardsView from '../pages/inf/views/cards.json';
import infInlineView from '../pages/inf/views/inline.json';
import infBacklogView from '../pages/inf/views/backlog.json';
import infSplitView from '../pages/inf/views/split.json';
import infCalendarView from '../pages/inf/views/calendar.json';
import infDashboardView from '../pages/inf/views/dashboard.json';

/** Тип запису «Сутність» зі сторінками пакета: меню, форми та подання з pages/inf/. */
export const infDefinition: IRecordTypeDefinition = {
  ...infEntity,
  views: assembleViewSet({
      table: infTableView,
      stages: infStagesView,
      cards: infCardsView,
      inline: infInlineView,
      backlog: infBacklogView,
      split: infSplitView,
      calendar: infCalendarView,
      dashboard: infDashboardView,
  }),
  form: infFullForm,
  forms: { full: infFullForm, context: infContextForm, mini: infMiniForm, lookup: infLookupForm },
  menu: infMenu,
} as IRecordTypeDefinition;
